// extracted by mini-css-extract-plugin
export default {"result":"input_result__JpWOl","head":"input_head__J2-ka","button":"input_button__TKToT","subhead":"input_subhead__QXicp"};